import React from 'react';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';

export const CreateMultipleTasksAction = ({ onClick }) => {
  if (!userHasPermission(Permissions.DailyPlan.CanUseModule)) return null;
  return (
    <FPIconButton
      onClick={onClick}
      showTooltipWhenDisabled
      icon={PlaylistAdd}
      tooltipProps={{
        arrow: false,
        placement: 'bottom',
        title: strings.dailyPlan.tableAction.add
      }}
      iconProps={{
        onSetColor: ({ primary }) => primary.main
      }}
    />
  );
};
